import React from 'react';
import { withTranslation } from "react-i18next";
import i18n from "i18next";
import CaAccountModalView from "./CaAccountModalView";
import { VIEW_LOGIN } from "../../constants/accountModalConstants";

const CaAccountCreateAccountContainer = props => {
    const {onNavigate } = props;
    const newProps = {
        onTopNavClick: () => onNavigate(VIEW_LOGIN),
        formFieldsData: [
            {   
                type:'text',
                validateAs:'text',
                placeholder:props.t('account_modal.placeholders.name'),
                id:"create_name"
            },
            {   
                type:'text',
                validateAs:'text',
                placeholder:props.t('account_modal.placeholders.lastname'),
                id:"create_lastname"
            },
            {   
                type:'email',
                validateAs:'email',
                placeholder:props.t('account_modal.placeholders.email'),
                id:"create_email"
            },
            {   
                type:'password',
                validateAs:'password',
                placeholder:props.t('account_modal.placeholders.password'),
                id:"create_password"},

            {   
                type:'password',
                validateAs:'password_repeat',
                placeholder:props.t('account_modal.placeholders.password_again'),
                id:"password_validation",
                validateToId:"create_password"
            },
        ],
        selectData: {
            type:'select',
            validateAs:'select',
            id:"create_country",
            data:i18n.store.data.en.translations.country_list,
            value:"SE"
        },
        checkboxData: {
            type:'checkbox',
            validateAs:'checkbox',
            id:"create_accept_pp",
            value:false,
            label:props.t('account_modal.accept_pp.label'),
            link:props.t('account_modal.accept_pp.link')
        },
        title: props.t('account_modal.create_account.title'), 
        body: props.t('account_modal.create_account.body'),
        topNavText: props.t('account_modal.create_account.topNavText'),
        topNavCta: props.t('account_modal.create_account.topNavCta'),
        submitCta: props.t('account_modal.create_account.submitCta'),
    };
    return (
        <CaAccountModalView {...{...props, ...newProps} } />
    )
}
export default withTranslation("translations")(CaAccountCreateAccountContainer);